import React, { Component } from 'react'
import {
    Container,
    Form,
    Button,
    Nav,
    NavItem,
    NavLink
} from 'reactstrap';


class review18_2 extends Component {
    render() {
        return (
            <div>
                <Container className="comming">
                <Form className="boxreview">
                        <h1 className="textrandomtest1">Review แบบทดสอบ</h1>
                        <Form className="Q1">
                           <h3 h5 align='center'>คะแนนที่คุณได้</h3>  <br></br>
                           <h1 h5 align='center'>2</h1><br></br>
                           
                           <h5 className="textreview">1. เวลาใดที่กินเวลาน้อยที่สุด </h5> <h5 className="textreviewtrue">(ท่านตอบข้อนี้ถูกต้อง)</h5>
                           <Form className="b1">
                           <h5 className="textreviewF">ก.อดีต</h5>
                           <h5 className="textreviewT">ข.ปัจจุบัน</h5>
                           <h5 className="textreviewF">ค.อนาคต</h5>
                           </Form>

                           <h5 className="textreview">2. คำกล่าวเกี่ยวกับอาณาจักรทวารวดีในข้อใดถูกต้องที่สุด</h5> <h5 className="textreviewfail">(ท่านตอบข้อนี้ผิด)</h5>
                           <Form className="b1">
                           <h5 className="textreviewT">ก. เป็นอาณาจักรแห่งแรกในดินแดนไทย</h5>
                           <h5 className="textreviewF">ข. ช่วยถ่ายทอดวัฒนธรรมไปสู่ดินแดนอื่น</h5>
                           <h5 className="textreviewF">ค. นำดินแดนไทยเข้าสู่สมัยประวัติศาสตร์</h5>
                        </Form>

                        <h5 className="textreview">3. โบราณสถานกับอาณาจักรโบราณในข้อใดที่จัดความสัมพันธ์ไม่ถูกต้อง</h5>  <h5 className="textreviewfail">(ท่านตอบข้อนี้ผิด)</h5>
                           <Form className="b1">
                           <h5 className="textreviewF">ก. พระปฐมเจดีย์  : ทวารวดี</h5>
                           <h5 className="textreviewF">ข. พระบรมธาตุเจดีย์  : ตามพรลิงค์</h5>
                           <h5 className="textreviewT">ค. พระธาตุหริภุญชัย : โยนกเชียงแสน</h5>
                        </Form>

                        <h5 className="textreview">4. เรื่องราวทางประวัติศาสตร์ในดินแดนไทยก่อนสมัยสุโขทัย  สามารถสรุปได้ตามข้อใด</h5> <h5 className="textreviewfail">(ท่านตอบข้อนี้ผิด)</h5>
                           <Form className="b1">
                           <h5 className="textreviewT">ก. ชุมชนมีการขยายตัวเป็นรัฐโบราณทั่วทุกภูมิภาค</h5>
                           <h5 className="textreviewF">ข. คนไทยได้รวมตัวก่อตั้งรัฐอิสระของตนขึ้นมา</h5>
                           <h5 className="textreviewF">ค. ผู้คนยุคหินได้สร้างบ้านแปลงเมืองจนเป็นอาณาจักร</h5>
                        </Form>

                        <h5 className="textreview">5. เหตุผลสำคัญที่ทำให้รัฐโบราณมักตั้งราชธานีอยู่ริมแม่น้ำหรือชายฝั่งทะเลคืออะไร</h5>  <h5 className="textreviewtrue">(ท่านตอบข้อนี้ถูกต้อง)</h5>
                           <Form className="b1">
                           <h5 className="textreviewF">ก. ใช้แหล่งน้ำเป็นปราการธรรมชาติป้องกันศัตรู</h5>
                           <h5 className="textreviewF">ข. พื้นที่เป็นดินอ่อนนุ่มสร้างบ้านเรือนได้ง่าย</h5>
                           <h5 className="textreviewT">ค. สะดวกแก่การเพาะปลูกและติดต่อค้าขาย</h5>
                        </Form>
                           
                           <p  h5 align='center'><Button href='/randomtest' color="#4fc3f7 light-blue lighten-2" >กลับหน้าหลัก</Button>{' '}</p>
                        </Form>
                       
                </Form>
                </Container>
               
                <div className="footer text-footer">
                    <p>Surasak   Noorurk</p>
                    <p> Project 5935512072 Computer Engineering</p>
                    <NavLink href="https://www.facebook.com/few.connectfve">ช่องทางการติดต่อ</NavLink>
                       
                </div>

            </div> 
        )
    }
}

export default review18_2